// Configures the shared axios instance. Imported first, and for its side effect
// only, so no request can be issued before the 401 interceptor is installed.
import "@/lib/http.ts";
import { scrubBreadcrumbUrls, scrubEventUrls } from "@/lib/sentryUrlScrub.ts";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";

Sentry.init({
  dsn: "https://12cb8e12e741fea1d138b8c6580e9c39@o4509605903728640.ingest.us.sentry.io/4509769226452992",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Logs
  enableLogs: true,
  environment: import.meta.env.MODE,
  integrations: [Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] })],
  // URL fragments carry secrets the browser never sends (claim-link token,
  // website sign-in capability); keep them out of the error tracker too.
  beforeBreadcrumb: scrubBreadcrumbUrls,
  beforeSend: scrubEventUrls,
  beforeSendTransaction: scrubEventUrls,
});

import { App } from "@/App.tsx";
import { installKeyboardModalityTracking } from "@/lib/keyboardModality.ts";
import "./index.css";

installKeyboardModalityTracking();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
